// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1izIj","filesListContainer":"PosDisputesFiles_filesListContainer__1Z1k9","filesButton":"PosDisputesFiles_filesButton__3HOr4"};